import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import {
  getAllRenterProperties,
  getAllRenterUnits,
  getOccupancyDetails,
} from 'modules/_common/api';

interface IProps {
  occupancyId: string | null;
  isEditingOccupancy: boolean;
  propertyId?: string;
  enabled?: boolean;
}

export const useQueryOccupancySidebarLite = ({
  occupancyId,
  isEditingOccupancy,
  propertyId,
  enabled = true,
}: IProps) => {
  const {
    data: propertyOptions,
    isError: errProperties,
    isLoading: isLoadingProperties,
  } = useQuery(QUERY_KEYS.LITE_RENTER_PROPERTIES, () => getAllRenterProperties(), {
    enabled: isEditingOccupancy && enabled,
    cacheTime: 0,
  });

  const {
    data: unitOptions,
    isError: errUnitOptions,
    isLoading: isLoadingUnitOptions,
  } = useQuery([QUERY_KEYS.LITE_RENTER_UNITS, propertyId], () => getAllRenterUnits(propertyId), {
    enabled: !!propertyId && enabled,
    cacheTime: 0,
  });

  const {
    data: occupancyData,
    isError: errOccupancyData,
    isLoading: loaderOccupancyData,
  } = useQuery(
    [QUERY_KEYS.LITE_OCCUPANCY_DETAILS, occupancyId],
    () => (occupancyId ? getOccupancyDetails(occupancyId) : null),
    {
      enabled: isEditingOccupancy && enabled && !!occupancyId,
      cacheTime: 0,
    },
  );

  return {
    isLoading: isLoadingProperties || loaderOccupancyData || isLoadingUnitOptions,
    isError: errProperties || errOccupancyData || errUnitOptions,
    propertyOptions: propertyOptions,
    unitOptions: unitOptions,
    occupancyData: occupancyData,
  };
};
